import { Component } from '@angular/core';

@Component({
    selector: 'app-freeway-layout-footer-social-facebook',
    templateUrl: './freeway-layout-footer-social-facebook.component.html',
    standalone: false
})
export class FreewayLayoutFooterSocialFacebookComponent {}
